import { v4 as uuidv4 } from 'uuid';
import { Types } from '../actions/typeContainer';

const PAYMENT_JOURNEY_KEY = 'paymentJourneyPathname';

// TODO: placeholder event names until the tracking team confirms the final ones.
// The campaign number keeps request_id identical for every send of the same booking, so GTM can deduplicate on it.
export const trackJourneyCompleted = (pathname: string, campaignNumber?: string | null) => {
  const journey = [Types.journey2, Types.journey3].find((type) => pathname.startsWith(`/${type}/`));

  if (journey) {
    (window as any).dataLayer?.push({ event: `${journey}_completed`, request_id: campaignNumber || uuidv4() });
  }
};

// The payment provider redirects back via /checkout/accept, which loses the originating journey.
export const setPaymentJourney = (pathname: string) => {
  try {
    sessionStorage.setItem(PAYMENT_JOURNEY_KEY, pathname);
  } catch (error) {
    console.warn('Error when saving payment journey to SS', error);
  }
};

export const clearPaymentJourney = () => {
  try {
    sessionStorage.removeItem(PAYMENT_JOURNEY_KEY);
  } catch (error) {
    console.warn('Error when clearing payment journey from SS', error);
  }
};

// Removed after reading so reloading the confirmation page doesn't track twice.
export const trackPaymentJourneyCompleted = (campaignNumber: string | null) => {
  try {
    const pathname = sessionStorage.getItem(PAYMENT_JOURNEY_KEY);
    sessionStorage.removeItem(PAYMENT_JOURNEY_KEY);

    if (pathname) {
      trackJourneyCompleted(pathname, campaignNumber);
    }
  } catch (error) {
    console.warn('Error when reading payment journey from SS', error);
  }
};
